export const parseJson = (jsonString: string) => {
  try {
    const jsonValue = JSON.parse(jsonString);
    return jsonValue;
  } catch (error) {
    return null;
  }
};

export const stringifyJson = (obj: any) => {
  try {
    return JSON.stringify(obj);
  } catch (error) {
    return '';
  }
};
